/* eslint max-len: 0 */
import React from 'react';
import i18n from '../libs/i18n';

import Section from './Section.jsx';
import { Layout, LayoutItem } from './Layout';
import Map from './Map.jsx';
import Plant from './Plant.jsx';

export default class SectionMap extends React.Component {
  render() {
    const contentBg = require('images/map-bg.svg');
    const title = i18n.translate('map.title');

    const mapAvSrc = require('../../images/map-av-vintage-3.jpg');
    const mapCeSrc = require('../../images/map-ce-vintage-3.jpg');

    return (
      <Section id={'map'} color={'white'} contentBg={contentBg} title={title}>
        <Layout direction={'column'} align="center" fallbackToRowAt="wide-screens">
          <LayoutItem weight={2}>
            <Layout direction={'column'}>
              <LayoutItem>
                <p dangerouslySetInnerHTML={{ __html: i18n.translate('map.p1') }}></p>
              </LayoutItem>
              <LayoutItem hide="under-wide-screens">
                <Plant src={mapAvSrc} title={i18n.translate('map.avTitle')} city={i18n.translate('map.avCity')} division={i18n.translate('map.avDivision')} />
                <Plant src={mapCeSrc} title={i18n.translate('map.ceTitle')} city={i18n.translate('map.ceCity')} division={i18n.translate('map.ceDivision')} />
              </LayoutItem>
            </Layout>
          </LayoutItem>
          <LayoutItem weight={1}>
            <Map />
          </LayoutItem>
          <LayoutItem full hide="wide-screens">
            <Plant src={mapAvSrc} title={i18n.translate('map.avTitle')} city={i18n.translate('map.avCity')} division={i18n.translate('map.avDivision')} />
            <Plant src={mapCeSrc} title={i18n.translate('map.ceTitle')} city={i18n.translate('map.ceCity')} division={i18n.translate('map.ceDivision')} />
          </LayoutItem>
        </Layout>
      </Section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/SectionMap.jsx
 **/